/* MysteryKitz PRE-ORDER (sections/mk-preorder.liquid).
   - "Alleen het shirt" or "met lijst": the button shows the price of the chosen option.
   - Adding goes through the cart API as JSON (/cart/add.js): only then does the cart refuse more than can ship.
     The frame is only ever added together with the shirt, in the same request.
   - A refusal (422) gets a neutral line, never a stock number. No form-post fallback: that would drop the frame.
   - ?uitvoering=lijst (or #met-lijst) preselects the frame; links with data-mkp-go jump to the buy box.
   - Sticky CTA: visible after the hero, hidden while the buy box or the closing box is on screen. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.querySelectorAll('[data-mkp]').forEach((root) => {
    if (root.dataset.mkpReady) return;
    root.dataset.mkpReady = 'true';

    let data = {};
    try {
      data = JSON.parse(root.querySelector('[data-mkp-data]').textContent);
    } catch (e) {}

    const buy = root.querySelector('#bestellen');
    const form = root.querySelector('[data-mkp-form]');
    const radios = form ? Array.from(form.querySelectorAll('input[type="radio"]')).filter((r) => r.name !== 'mkp-size') : [];
    const checked = () => radios.find((r) => r.checked);
    const sync = () => {
      const c = checked();
      if (!c) return;
      root.querySelectorAll('[data-mkp-add-price], [data-mkp-sticky-price]').forEach((el) => {
        el.textContent = c.dataset.price || el.textContent;
      });
    };
    const pick = (value) => {
      const r = radios.find((x) => x.value === value && !x.disabled);
      if (r) {
        r.checked = true;
        sync();
      }
    };

    const params = new URLSearchParams(window.location.search);
    if (params.get('uitvoering') === 'lijst' || window.location.hash === '#met-lijst') pick('frame');
    sync();

    root.querySelectorAll('a[data-mkp-go]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!buy) return;
        event.preventDefault();
        if (link.dataset.mkpGo) pick(link.dataset.mkpGo);
        buy.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        const focusEl = checked();
        if (focusEl) setTimeout(() => focusEl.focus({ preventScroll: true }), reduceMotion ? 0 : 600);
      });
    });

    // Size choice for the Feyenoord shirt: one shared stock (one variant), the size travels as line-item property "Maat".
    let sizeBox = form ? form.querySelector('.mkf-size') : null;
    if (sizeBox) {
      if (!document.getElementById('mkp-size-css')) {
        const st = document.createElement('style');
        st.id = 'mkp-size-css';
        st.textContent = '.mkf .mkf-size{display:flex;flex-wrap:wrap;align-items:center;gap:10px 14px;margin:0 0 18px;font-size:inherit;color:inherit}.mkf-size__label{font-size:var(--mk-fs-label,12px);letter-spacing:var(--mk-ls-label,.08em);text-transform:uppercase;font-weight:600;color:var(--mk-muted)}.mkf-size__note{flex-basis:100%;margin:0;font-size:13px;color:var(--mk-muted);line-height:1.5}.mkf-sizes{display:flex;flex-wrap:wrap;gap:8px}.mkf-sizeopt{position:relative;margin:0}.mkf-sizeopt input{position:absolute;width:1px;height:1px;opacity:0}.mkf-sizeopt span{min-width:48px;height:40px;padding:0 12px;display:grid;place-items:center;border:1px solid var(--mk-line-strong);background:#fff;font-weight:600;cursor:pointer;transition:border-color .15s}.mkf-sizeopt:hover span{border-color:var(--mk-gold)}.mkf-sizeopt input:checked+span{border-color:var(--mk-ink);box-shadow:inset 0 0 0 1px var(--mk-ink)}.mkf-sizeopt input:focus-visible+span{outline:2px solid var(--mk-gold-deep);outline-offset:2px}';
        document.head.appendChild(st);
      }
      // Older markup without size buttons: build them here (as a div, a <p> cannot hold the button group).
      if (!sizeBox.querySelector('input[name="mkp-size"]')) {
        if (sizeBox.tagName === 'P') {
          const div = document.createElement('div');
          div.className = sizeBox.className;
          sizeBox.replaceWith(div);
          sizeBox = div;
        }
        const sizes = Array.isArray(data.sizes) && data.sizes.length ? data.sizes : ['S', 'M', 'L', 'XL'];
        sizeBox.innerHTML = '<span class="mkf-size__label" id="mkp-size-label">Maat</span>' +
          '<div class="mkf-sizes" role="radiogroup" aria-labelledby="mkp-size-label">' +
          sizes.map((s) => '<label class="mkf-sizeopt"><input type="radio" name="mkp-size" value="' + s + '"' + (s === 'M' ? ' checked' : '') + '><span>' + s + '</span></label>').join('') +
          '</div><p class="mkf-size__note">Kies je maat. M is de fijnste maat om in te lijsten.</p>';
      }
    }

    // The facts list may still name one size; all sizes are available.
    root.querySelectorAll('.mkf-facts li').forEach((li) => {
      if (/^Maat\s+[A-Z]{1,3}$/.test(li.textContent.trim())) li.textContent = 'Maat S, M, L of XL';
    });

    if (form) {
      const error = form.querySelector('[data-mkp-error]');
      const addBtn = form.querySelector('[data-mkp-add]');
      const say = (msg) => {
        if (!error) return;
        error.textContent = msg || '';
        error.hidden = !msg;
      };
      form.addEventListener('change', () => {
        sync();
        say('');
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        const shirtId = parseInt(form.dataset.shirt, 10);
        const frameId = parseInt(form.dataset.frame, 10);
        if (!shirtId) return;
        const c = checked();
        const framed = !!(c && c.value === 'frame' && frameId);
        const props = data.props || {};
        const size = form.querySelector('input[name="mkp-size"]:checked');
        const shirtProps = Object.assign({}, size ? { Maat: size.value } : {}, (framed ? props.shirtFramed : props.shirtOnly) || {});
        const items = [{ id: shirtId, quantity: 1, properties: shirtProps }];
        if (framed) items.push({ id: frameId, quantity: 1, properties: props.frame || {} });
        const done = () => {
          form.removeAttribute('aria-busy');
          if (addBtn) addBtn.disabled = false;
        };
        form.setAttribute('aria-busy', 'true');
        if (addBtn) addBtn.disabled = true;
        say('');
        fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((res) => {
            if (res.ok) {
              window.location.href = `${shopRoot}cart`;
              return;
            }
            done();
            say(res.status === 422 ? data.msgFull : data.msgError);
          })
          .catch(() => {
            done();
            say(data.msgError);
          });
      });
    }

    const bar = root.querySelector('.mkp-sticky');
    const hero = root.querySelector('.mkp-hero');
    const close = root.querySelector('.mkp-close');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    let pastHero = false;
    let buyVisible = false;
    let closeVisible = false;
    const show = () => {
      bar.hidden = !(pastHero && !buyVisible && !closeVisible);
    };
    new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      show();
    }).observe(hero);
    if (buy) {
      new IntersectionObserver(([entry]) => {
        buyVisible = entry.isIntersecting;
        show();
      }, { rootMargin: '0px 0px -25% 0px' }).observe(buy);
    }
    if (close) {
      new IntersectionObserver(([entry]) => {
        closeVisible = entry.isIntersecting;
        show();
      }).observe(close);
    }
  });
})();
